// StaffPageSkeleton.jsx
import React from "react";
import "./staffPageSkeleton.css";

const StaffPageSkeleton = () => {
	return (
		<div className="sf-staff-skel">

			{/* HEADER */}
			<div className="sf-skel-row gap">
				<div className="sf-skel-circle shimmer"></div>
				<div className="sf-skel-line w-40 shimmer"></div>
			</div>

			{/* PROFILE */}
			<div className="sf-skel-profile-header">
				<div className="sf-skel-avatar shimmer"></div>

				<div className="sf-skel-profile-info">
					<div className="sf-skel-line w-50 shimmer"></div>
					<div className="sf-skel-line w-70 shimmer"></div>
					<div className="sf-skel-line w-60 shimmer"></div>
				</div>
			</div>

			{/* SERVICES TITLE */}
			<div className="sf-skel-row between">
				<div className="sf-skel-line w-30 shimmer"></div>
				<div className="sf-skel-pill shimmer"></div>
			</div>

			{/* SERVICES LIST */}
			<div className="sf-skel-service-list">
				{Array.from({ length: 4 }).map((_, i) => (
					<div key={i} className="sf-skel-service-row shimmer">
						<div className="sf-skel-row">
							<div className="sf-skel-line w-60 shimmer"></div>
						</div>
						<div className="sf-skel-row space">
							<div className="sf-skel-line w-40 shimmer"></div>
							<div className="sf-skel-btn shimmer"></div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default StaffPageSkeleton;
